export default __webpack_public_path__ + "static/media/pakistan.e5aabd30.png";